import { render } from "./SalesOrder.vue?vue&type=template&id=2166f77f"
import script from "./SalesOrder.vue?vue&type=script&lang=js"
export * from "./SalesOrder.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/reps.mlelectronics.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__